module.exports = __webpack_public_path__ + "img/acaki4.6caf5552.jpg";